// mukul_theme

export default [
	{
		featureType: "all",
		elementType: "labels.text.fill",
		stylers: [
			{
				saturation: 36,
			},
			{
				color: "#000000",
			},
			{
				lightness: 40,
			},
		],
	},
	{
		featureType: "all",
		elementType: "labels.text.stroke",
		stylers: [
			{
				visibility: "on",
			},
			{
				color: "#000000",
			},
			{
				lightness: 16,
			},
		],
	},
	{
		featureType: "all",
		elementType: "labels.icon",
		stylers: [
			{
				visibility: "off",
			},
		],
	},
	{
		featureType: "administrative",
		elementType: "geometry.fill",
		stylers: [
			{
				lightness: 20,
			},
			{
				color: "#000000",
			},
		],
	},
	{
		featureType: "administrative",
		elementType: "geometry.stroke",
		stylers: [
			{
				color: "#000000",
			},
			{
				lightness: 17,
			},
			{
				weight: 1.2,
			},
		],
	},
	{
		featureType: "administrative.country",
		elementType: "labels.text.fill",
		stylers: [
			{
				visibility: "on",
			},
			{
				color: "#ffffff",
			},
		],
	},
	{
		featureType: "administrative.province",
		elementType: "geometry.fill",
		stylers: [
			{
				visibility: "simplified",
			},
		],
	},
	{
		featureType: "administrative.province",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#ffffff",
			},
		],
	},
	{
		featureType: "administrative.province",
		elementType: "labels.text.stroke",
		stylers: [
			{
				weight: "0.01",
			},
			{
				invert_lightness: true,
			},
			{
				color: "#f26c4f",
			},
		],
	},
	{
		featureType: "landscape",
		elementType: "geometry",
		stylers: [
			{
				color: "#000000",
			},
			{
				lightness: 20,
			},
		],
	},
	{
		featureType: "poi",
		elementType: "geometry",
		stylers: [
			{
				color: "#000000",
			},
			{
				lightness: 21,
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.fill",
		stylers: [
			{
				visibility: "simplified",
			},
			{
				weight: "0.05",
			},
			{
				color: "#ffffff",
			},
			{
				lightness: 17,
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "geometry.stroke",
		stylers: [
			{
				color: "#f26c4f",
			},
			{
				weight: "0.10",
			},
			{
				invert_lightness: true,
			},
			{
				lightness: 29,
			},
		],
	},
	{
		featureType: "road.highway",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#f26c4f",
			},
		],
	},
	{
		featureType: "road.highway.controlled_access",
		elementType: "geometry",
		stylers: [
			{
				weight: "0.30",
			},
		],
	},
	{
		featureType: "road.arterial",
		elementType: "geometry",
		stylers: [
			{
				color: "#000000",
			},
			{
				lightness: 18,
			},
		],
	},
	{
		featureType: "road.local",
		elementType: "geometry",
		stylers: [
			{
				color: "#000000",
			},
			{
				lightness: 16,
			},
		],
	},
	{
		featureType: "transit",
		elementType: "geometry",
		stylers: [
			{
				color: "#000000",
			},
			{
				lightness: 19,
			},
		],
	},
	{
		featureType: "water",
		elementType: "geometry",
		stylers: [
			{
				color: "#000000",
			},
			{
				lightness: 17,
			},
		],
	},
];
